// extracted by mini-css-extract-plugin
export default {"header":"section-header_header__whgdl","label":"section-header_label__-OE+9","separator":"section-header_separator__uulxD","description":"section-header_description__5PEzy"};